// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__34h7Y","row":"Node_row__WDcAx","label":"Node_label__5UT87","footer":"Node_footer__3zLzb"};